import { Checkbox } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniCheckboxItem = withUnistyles(Checkbox.Item)

export default UniCheckboxItem
